module.exports = __webpack_public_path__ + "static/img/case_18.e1cf147.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_18.jpg
// module id = k+8T
// module chunks = 0